import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { environment } from '../../environment/environment';
import { RbacService } from '../services/rbac/permission.service';
import { PostLoginNavigationService } from '../shared/navigation/post-login-navigation.service';
import { CRM_SUMMARY_URL } from '../shared/navigation/return-url.util';

/**
 * Architects (`isAssigned`), PMs (`isPM`), and Management (`isManagement`) always access Home.
 * When `enableHomePmViewDropdown` is on, Home renders immediately (assignment loads in the background).
 * Otherwise users who are none of those roles with CRM access are sent to CRM Overview.
 */
export const architectHomeGuard: CanActivateFn = () => {
  const postLoginNavigation = inject(PostLoginNavigationService);
  const rbac = inject(RbacService);
  const router = inject(Router);

  if (environment.enableHomePmViewDropdown === true) {
    postLoginNavigation.refreshAssignment().subscribe();
    return true;
  }

  return postLoginNavigation.refreshAssignment().pipe(
    map((canLandOnHome) => {
      if (canLandOnHome) {
        return true;
      }
      if (!rbac.hasCrmModuleAccess()) {
        return true;
      }
      return router.parseUrl(CRM_SUMMARY_URL);
    }),
  );
};
